function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import MembershipService from "@xo-union/sdk-membership";
import noop from "lodash/noop";
var normalizeParams = function normalizeParams(params) {
  var passThroughParams;
  var onSuccess;
  var onError;
  if (params[0] && _typeof(params[0]) === 'object') {
    var _params = _slicedToArray(params, 3);
    passThroughParams = _params[0];
    var _params$ = _params[1];
    onSuccess = _params$ === void 0 ? noop : _params$;
    var _params$2 = _params[2];
    onError = _params$2 === void 0 ? noop : _params$2;
  } else {
    var _params2 = _slicedToArray(params, 2);
    var _params2$ = _params2[0];
    onSuccess = _params2$ === void 0 ? noop : _params2$;
    var _params2$2 = _params2[1];
    onError = _params2$2 === void 0 ? noop : _params2$2;
  }
  return [passThroughParams, onSuccess, onError];
};
var defaultMembershipService = new MembershipService({
  clientOptions: {
    includeWeddingProperties: true
  }
});
var membershipActionFactory = function membershipActionFactory(types, membershipCallback) {
  return function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    var _normalizeParams = normalizeParams(params),
      _normalizeParams2 = _slicedToArray(_normalizeParams, 3),
      passThroughParams = _normalizeParams2[0],
      onSuccess = _normalizeParams2[1],
      onError = _normalizeParams2[2];
    return function (dispatch, getState) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$membershipServic = _ref.membershipService,
        membershipService = _ref$membershipServic === void 0 ? defaultMembershipService : _ref$membershipServic;
      dispatch({
        type: types.progress
      });
      return membershipCallback(membershipService, passThroughParams).then(function (result) {
        dispatch({
          type: types.success,
          payload: result.data || {}
        });
        return result.data;
      }).then(onSuccess)["catch"](function (error) {
        dispatch({
          type: types.error,
          error: error
        });
        onError(error);
      });
    };
  };
};
export default membershipActionFactory;